import * as React from 'react';

import { t } from 'utils/t';

import { Wrapper, PageTitle, LinkFields, CouponFields, Body, ControlsCreate } from '../components';

import { REGISTRATION_LINKS_FORM_ID } from '../constants';

import { handleSubmitNew } from '../actions/create';

export const New = () => {
  return (
    <Wrapper id={REGISTRATION_LINKS_FORM_ID} onSubmit={handleSubmitNew} cleanErrorOnChange>
      <Body>
        <PageTitle>{t.staticAsString('smartLinks.newSmartLink')}</PageTitle>
        <LinkFields />
        <CouponFields />
        <ControlsCreate />
      </Body>
    </Wrapper>
  );
};
